import { useTranslation } from 'react-i18next';

import { SidebarNotificationCard } from 'src/features/sidebar/SidebarNotificationCard';
import { SidebarNotificationStack } from 'src/features/sidebar/SidebarNotificationStack';
import { useSidebarUpdate } from 'src/features/sidebar/useSidebarUpdate';
import { useAppDispatch } from 'src/hooks/useStore';
import {
  togglePrimarySidebarMobile,
  toggleReferralPromoModalAction,
} from 'src/store/ui/actions';

import { useReferralPromo } from './useReferralPromo';

/**
 * The growth-loops sidebar stack: a pending app update in front, the referral
 * promo behind it. Replaces the standalone update card while the flag is on.
 */
export function SidebarNotifications() {
  const { t } = useTranslation();
  const update = useSidebarUpdate();
  const referralPromo = useReferralPromo();
  const dispatch = useAppDispatch();

  const cards = [
    ...(update
      ? [
          {
            key: 'update',
            node: (
              <SidebarNotificationCard
                description={update.description}
                icon="Repeat"
                onClick={update.apply}
                title={update.title}
              />
            ),
          },
        ]
      : []),
    ...(referralPromo.isVisible
      ? [
          {
            key: 'referral-promo',
            node: (
              <SidebarNotificationCard
                description={t(
                  ($) => $.page_settings_referrals.promo.description,
                )}
                dismissLabel={t(($) => $.page_settings_referrals.promo.dismiss)}
                icon="Gift"
                onClick={() => {
                  // On phones the sidebar is a drawer that would stay open
                  // behind the popup.
                  dispatch(togglePrimarySidebarMobile({ isOpen: false }));
                  dispatch(toggleReferralPromoModalAction(true));
                }}
                onDismiss={referralPromo.dismiss}
                testId="sidebar-referral-promo"
                title={t(($) => $.page_settings_referrals.promo.title)}
              />
            ),
          },
        ]
      : []),
  ];

  return <SidebarNotificationStack cards={cards} />;
}
